import { PAGE_URL } from "configs/constant";

const handleOnClickRefLink = (phone) => {
  const refLink = `${PAGE_URL}?register=true&ref=${phone}`;
  navigator.clipboard.writeText(refLink);
};

export { handleOnClickRefLink };
